import React, { useEffect } from 'react';
import { SeoBar } from '../components/SeoBar';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { HeroSection } from './edm-network-fast-wire/HeroSection';
import { BreadcrumbSection } from './edm-network-fast-wire/BreadcrumbSection';
import { DescriptionSection } from './edm-network-fast-wire/DescriptionSection';
import { VerticalHeaderSection } from './edm-network-fast-wire/VerticalHeaderSection';
import { VerticalProductsSection } from './edm-network-fast-wire/VerticalProductsSection';
import { HorizontalHeaderSection } from './edm-network-fast-wire/HorizontalHeaderSection';
import { HorizontalProductsSection } from './edm-network-fast-wire/HorizontalProductsSection';
export function EDMNetworkFastWirePage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen w-full bg-white flex flex-col" data-id="element-2134">
      <SeoBar data-id="element-2135" />
      <Header data-id="element-2136" />
      <main className="flex-grow" data-id="element-2137">
        <div className="w-full bg-gray-50 pb-20 min-h-screen" data-id="element-2138">
          <HeroSection data-id="element-2139" />
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-2140">
            <BreadcrumbSection data-id="element-2141" />
            <DescriptionSection data-id="element-2142" />
            <div className="space-y-16" data-id="element-2143">
              <div data-id="element-2144">
                <VerticalHeaderSection data-id="element-2145" />
                <VerticalProductsSection data-id="element-2146" />
              </div>
              <div data-id="element-2147">
                <HorizontalHeaderSection data-id="element-2148" />
                <HorizontalProductsSection data-id="element-2149" />
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer data-id="element-2150" />
    </div>;
}